
export default function(intervalMilliseconds) {
    var queueToBePresented = [];
    var invisibleElements = document.querySelectorAll('.queue-present');

    if (!('IntersectionObserver' in window) || intervalMilliseconds === 0) {
        invisibleElements.forEach((el) => el.classList.remove('queue-present'));
        return;
    }

    var observerVisible = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting && !(entry.target.classList.contains("present"))) {
                queueToBePresented.push(entry.target);
            }
        });
    });

    invisibleElements.forEach((el) => observerVisible.observe(el));

    setInterval(function(){
        if (queueToBePresented.length) {
            while (queueToBePresented.length > 5) {
                queueToBePresented.shift().classList.add('present');
            }
            queueToBePresented.shift().classList.add('present');
        }
    }, intervalMilliseconds);
};
